module.exports = __webpack_public_path__ + "static/img/appTwoCode.2232eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appTwoCode.png
// module id = i2xK
// module chunks = 1